
import { Component, Prop, Vue } from 'vue-property-decorator';
import { isMobile } from '@/utils/tool';

@Component
export default class Footer extends Vue {
  @Prop({ default: false }) showAppInfo!: boolean;
  @Prop({ default: false }) isBaiduDeveloper!: boolean;
  @Prop({ default: true }) showAddress!: boolean;
  @Prop({ default: '' }) developerName!: string;

  public isMobile = isMobile();
}
